import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
export function HeroSection() {
  return <section id="hero" className="relative w-full flex flex-col items-center justify-between px-5 pb-3 bg-[#F8F5FC] overflow-hidden" style={{
    height: 'calc(100dvh - 32px)',
    paddingTop: 'max(env(safe-area-inset-top, 0px), 0.75rem)'
  }} data-id="element-134">
      <div className="relative z-10 flex flex-col items-center text-center max-w-lg w-full flex-1 justify-between min-h-0 py-2" data-id="element-135">
        {/* Eyebrow + headline */}
        <div className="flex flex-col items-center gap-1.5 flex-shrink-0" data-id="element-136">
          <p className="hero-fade-1 text-brand-violet text-[11px] font-bold uppercase tracking-[0.18em]" data-id="element-137">
            Biología Femenina · Método pH-ZERO
          </p>
          <h1 className="hero-fade-2 text-[26px] sm:text-[32px] font-bold leading-[1.08] text-brand-text" data-id="element-138">
            Cándida recurrente: el ciclo que nadie te explicó (y cómo cortarlo)
          </h1>
        </div>

        {/* Mockup */}
        <img src="https://cdn.magicpatterns.com/uploads/qeMGyiRr8YXTyoDvtX1uxE/IMG_0034.png" alt="Método pH-ZERO" className="hero-fade-2 w-full max-w-[230px] sm:max-w-[300px] h-auto object-contain min-h-0 flex-shrink" data-id="element-139" />

        {/* Subtitle */}
        <p className="hero-fade-3 text-[14px] sm:text-[15px] text-brand-muted leading-snug px-2 flex-shrink-0" data-id="element-140">
          La guía completa para cortar la cándida recurrente{' '}
          <strong className="text-brand-text" data-id="element-141">de raíz</strong> — con
          alimentación y hábitos para que no vuelva.
        </p>

        <div className="w-full flex flex-col items-center gap-2.5 flex-shrink-0" data-id="element-142">
          {/* Feature pills */}
          <div className="hero-fade-4 flex flex-wrap items-center justify-center gap-1.5" data-id="element-143">
            <span className="inline-flex items-center gap-1 bg-white border border-brand-gray rounded-full px-3 py-1 text-[11px] font-semibold text-brand-text shadow-sm" data-id="element-144">
              📄 PDF
            </span>
            <span className="inline-flex items-center gap-1 bg-white border border-brand-gray rounded-full px-3 py-1 text-[11px] font-semibold text-brand-text shadow-sm" data-id="element-145">
              ⚡ Acceso Inmediato
            </span>
            <span className="inline-flex items-center gap-1 bg-white border border-brand-gray rounded-full px-3 py-1 text-[11px] font-semibold text-brand-text shadow-sm" data-id="element-146">
              📚 6 Tomos + 3 Bonus
            </span>
          </div>

          {/* CTA */}
          <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: 'Hero CTA',
          value: 19990,
          currency: 'ARS'
        })} className="hero-fade-5 w-full bg-brand-magenta hover:brightness-110 text-white font-bold text-[15px] rounded-xl py-3.5 px-6 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-147">
            🔓 QUIERO MATAR AL HONGO
          </a>

          {/* Trust bar */}
          <div className="hero-fade-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[10px] text-brand-muted font-medium" data-id="element-148">
            <span data-id="element-149">🛡️ Garantía 7 días</span>
            <span data-id="element-150">·</span>
            <span data-id="element-151">🔒 Pago seguro</span>
            <span data-id="element-152">·</span>
            <span data-id="element-153">💳 Tarjetas y transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}